import type { FC, HTMLProps } from "react";

import { cn } from "mds/utils/cn";

type CardProps = HTMLProps<HTMLDivElement> & {
  isActive?: boolean;
  small?: boolean;
  kind?: "default" | "blue";
};

const KIND_TO_TW_CLASSES: Record<CardProps["kind"], string> = {
  default: "bg-white shadow-level-1 rounded-md",
  blue: "bg-blue-tint-95 rounded-md",
};

const KIND_TO_ACTIVE_TW_CLASSES: Record<CardProps["kind"], string> = {
  default: "border-l-4 border-blue shadow-level-2",
  blue: "",
};

const spacingClasses = (active: boolean, small: boolean) => {
  if (small) {
    return active ? "pl-2 pr-3 py-2.5" : "px-3 py-2.5";
  }
  return active ? "pl-3 pr-4 py-3" : "px-4 py-3";
};

/**
 * A simple stylized card component that adds some padding and a white background.
 * The `isActive` prop can be used to add a border to the card.
 */
export const Card: FC<CardProps> = ({
  children,
  small,
  kind = "default",
  className,
  isActive = false,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(
        "card",
        small && "card-small",
        KIND_TO_TW_CLASSES[kind],
        isActive && KIND_TO_ACTIVE_TW_CLASSES[kind],
        spacingClasses(isActive, small),
        className,
      )}
    >
      {children}
    </div>
  );
};
